module.exports = __webpack_public_path__ + "AG.png?8ffe9c5c4e9debf4ff025e4034b0f916";